module.exports = __webpack_public_path__ + "img/example_4.ccc075f4.png";